import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";

//import * as actionsInscripcion from '../../_redux/inscripcion/inscripcionActions';
import * as actionsAspirante from '../../_redux/aspirante/aspiranteActions';
import * as actionsPasoUno from '../../_redux/pasoUno/pasoUnoActions';

import { PreInscripcionUIConsumer, PreInscripcionUIContext } from '../../PreInscripcionUIContext';
//BOTONES
import Volver from '../../components/Volver';
import Continuar from '../../components/Continuar';
import Editar from '../../components/Editar';

//ICONOS
import ErrorIcon from '@material-ui/icons/Error';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';

//MATERIAL UI CARD  
import { Card, CardContent } from '@material-ui/core'

import SnackBarCustom from '../../../../Comun/SnackBars/SnackBarCustom';

//Formik
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Spinner } from 'react-bootstrap'


const Documentacion = (props) => {
    const dispatch = useDispatch();
    const { valoresDocumentacionAspirante, valoresDocumentacionResponsable } = useContext(PreInscripcionUIContext)
    const { buscando, tipo, posicion, setCantidad, setVerDatosPersonales, verDatosPersonales, setVerDomicilio } = props;

    const { pasoUno, aspirante } = useSelector(
        (state) => ({ 
            pasoUno: state.pasoUno, 
            aspirante: state.aspirante 
        }),
        shallowEqual
    );
    const {
        responsables,
        actionsLoading: actionsLoadingPaso1,
        error: errorPaso1
    } = pasoUno;
    const {
        error: errorAspirante,
        //entities: estitiesAspirante
        actionsLoading: actionsLoadingAspirante,
    } = aspirante;

    const [disabled, setDisabled] = useState(false);
    const [contador, setContador] = useState(0);
    const [existeDNI, setExisteDNI] = useState(false);

    const documentacionSchema = Yup.object().shape({
        sexo: Yup.string()
            .required("Debe seleccionar el sexo"),
        documentoNumero: Yup.string()
            .matches(/^\d+$/, "Solo debe ingresar números")
            .required("Debe ingresar el número de documento"),
        /*No se usa mas. LLamada 30/11/2020 entre todos.
        documentoTramiteNumero: Yup.string()
            .matches(/^\d+$/, "Solo debe ingresar números")
            .required("Debe ingresar el número de tramite de la documentación"),*/
    });

    function formularioCompleto(cantidad) {
        setVerDatosPersonales(true);
        setContador(contador + 1);
        setDisabled(true);
        setCantidad(cantidad);
    };

    useEffect(() => {
        if (contador > 0 && contador < 2) {
            setContador(contador + 1);
            setDisabled(true);
        };
        if (responsables.length > 0 && contador < 2) {
            setContador(contador + 1);
            setDisabled(true);
        };

    }, [contador, responsables]);

    useEffect(() => {
        
    }, [buscando]);

    const datosPersonales = tipo === "responsable" ? valoresDocumentacionResponsable(posicion) : valoresDocumentacionAspirante();

    const tarjetaIndicativa = (verDatosPersonales, datosPersonales, valoresExtrasAspirante) => {
        return (
            <Card style={{ backgroundColor: "#f7f7f7" }}>
                <CardContent className="d-flex flex-row align-items-center ml-2">
                    {buscando ? (
                        <>
                            <div className="border-left border-2 border-secondary p-3 br-4">
                                <Spinner animation="border" variant="success" />
                            </div>
                            <div style={{ minHeight:"84px" }}>
                                <b>AGUARDE UN MOMENTO</b>
                                <p>Estamos procesando los datos ingresados.</p>
                                <p></p>
                                <p></p>
                            </div>
                        </>
                    ) : (
                        !!valoresExtrasAspirante && valoresExtrasAspirante.inscripcionVinculadaId && valoresExtrasAspirante.inscripcionVinculadaId > 0
                            ? <>
                                <div className="border-left border-2 border-danger p-3 br-4">
                                    <CloseIcon fontSize="large" style={{color: "#F64E60"}} />
                                </div>
                                <div style={{ minHeight:"84px" }}>
                                    <b>IMPORTANTE!</b>
                                    <p>El aspirante ingresado ya se ha encontrado en otra inscripción. Por favor comuniquese con mesa de ayuda!</p>
                                    <small>Código de la inscripción: <b>{valoresExtrasAspirante.inscripcionVinculadaNumero}</b></small>
                                </div>
                            </>
                            : !verDatosPersonales 
                                ? <>
                                    <div className="border-left border-2 border-secondary p-3 br-4">
                                        <ErrorIcon color="secondary" fontSize="large" />
                                    </div>
                                    <div style={{ minHeight:"84px" }}>
                                        <b>AVISO</b>
                                        <p>Ingresá los datos para ser corroborados en el registro civil</p>
                                        <p></p>
                                        <p></p>
                                    </div>
                                </>
                                : !!datosPersonales.personaRegistroCivilId && datosPersonales.personaRegistroCivilId > 0
                                    ? <>
                                        <div className="border-left border-2 border-success p-3 br-4">
                                            <DoneIcon color="primary" fontSize="large" />
                                        </div>
                                        <div style={{ minHeight:"84px" }}>
                                            <b>PERFECTO!</b>
                                            <p>El DNI ingresado ha sido validado por el registro de las personas</p>
                                        </div>
                                    </>
                                    : <>
                                        <div className="border-left border-2 border-danger p-3 br-4">
                                            <CloseIcon fontSize="large" style={{color: "#F64E60"}} />
                                        </div>
                                        <div style={{ minHeight:"84px" }}>
                                            <b>IMPORTANTE!</b>
                                            <p>No hemos podido validar los datos con el registro de las personas. De todas maneras podes continuar con el proceso.</p>
                                        </div>
                                    </>
                    )}
                </CardContent>
            </Card>
        );
    };

    return (
        <PreInscripcionUIConsumer>
            {value =>
                <>
                    {tipo === "responsable" && value.setPosicion(posicion)}
                    {tipo === "responsable" && setCantidad(value.cantidadResponsables())}
                    {   tipo === "aspirante" &&
                        value.valoresExtrasAspirante() &&
                        value.valoresExtrasAspirante().id &&
                        value.valoresExtrasAspirante().id > 0 &&
                        contador === 0 &&
                        formularioCompleto(value.cantidadResponsables())
                    }
                    {   tipo === "responsable" &&
                        responsables.length > 0 &&
                        responsables.length > posicion &&
                        responsables[posicion].email &&
                        responsables[posicion].telefono &&
                        responsables[posicion].vinculo &&
                        contador === 0 &&
                        formularioCompleto(value.cantidadResponsables())
                    }
                    {tarjetaIndicativa(verDatosPersonales, datosPersonales, value.valoresExtrasAspirante())}
                    <br />
                    <h3 className="text-center" >
                        DATOS DEL {tipo.toUpperCase()}
                    </h3>
                    <div className="d-flex flex-row justify-content-between">
                        <p className="font-weight-bold">Documentación</p>
                        <p className="text-muted">(*)Campos Obligatorios</p>
                    </div>
                    <Formik
                        enableReinitialize
                        initialValues={tipo === "responsable" ? value.valoresDocumentacionResponsable(posicion) : value.valoresDocumentacionAspirante()}
                        validationSchema={documentacionSchema}
                        onSubmit={(values, { setSubmitting }) => {
                            //console.log(value.verificarDNIS(values.documentoNumero,values.sexo));
                            if (tipo === "responsable" && value.verificarDNIS(values.documentoNumero, values.sexo, posicion)) {
                                setExisteDNI(true);
                                setSubmitting(false);
                            } else {
                                setExisteDNI(false);
                                values.registroCivilvalidacion = false;
                                if (tipo === "aspirante") {
                                    value.dispatchDatosPeronales({ type: 'guardarAspiranteDocumentacion', payload: values });
                                    dispatch(actionsAspirante.fetchAspiranteInformacion({ sexo: values.sexo, nroDocumento: values.documentoNumero }));
                                    if (!actionsLoadingAspirante && !errorAspirante) {
                                        setTimeout(() => {
                                            formularioCompleto(value.cantidadResponsables());
                                            setSubmitting(false);
                                        }, 1000);
                                    };
                                };
                                if (tipo === "responsable") {
                                    values.posicion = posicion;
                                    value.dispatchDatosPeronales({ type: 'guardarResponsableDocumentacion', payload: values });
                                    dispatch(actionsPasoUno.fetchResponsableInfromacion({ sexo: values.sexo, nroDocumento: values.documentoNumero, posicion }));
                                    if (!actionsLoadingPaso1 && !errorPaso1) {
                                        setTimeout(() => {
                                            formularioCompleto(value.cantidadResponsables());
                                            setSubmitting(false);
                                        }, 1000);
                                    };
                                };
                            };
                        }}
                    >
                        {formik =>
                            <Form>
                                <div className="row justify-content-between align-items-top" >
                                    <div className="form-group col-12 col-md-6" >
                                        <label htmlFor="sexo">Seleccionar Sexo*</label>
                                        <Field name="sexo" as="select" className="form-control" disabled={disabled} >
                                            {!formik.values.sexo && <option value="">Sexo</option>}
                                            <option value="M">Masculino</option>
                                            <option value="F">Femenino</option>
                                        </Field>
                                        <div className="text-danger"><ErrorMessage name="sexo" /></div>
                                    </div>
                                    <div className="form-group col-12 col-md-6 justify-content-bottomm">
                                        <label htmlFor="documentoNumero">Ingresar Número de Documento*</label>
                                        <Field
                                            name="documentoNumero"
                                            type="text"
                                            maxLength={value.maxDocumentoNumero}
                                            className="form-control"
                                            placeholder="Número de Documento"
                                            disabled={disabled}
                                            autoComplete="off"
                                        />
                                        <small>Solo números sin puntos o comas</small>
                                        <div className="text-danger"><ErrorMessage name="documentoNumero" /></div>
                                    </div>
                                </div>
                                {existeDNI &&
                                    <div className="mb-4 text-danger text-center"> El número de documento ya fue utilizado en esta inscripción, por favor ingrese otro.</div>
                                }
                                {verDatosPersonales ?
                                    <div className="row justify-content-center mb-3">
                                        {disabled && <Editar setDisabled={setDisabled} setVerDatosPersonales={setVerDatosPersonales} setVerDomicilio={setVerDomicilio} />}
                                        {!disabled && <Continuar spinner={buscando} />}
                                    </div>
                                    :
                                    <div className="row justify-content-center mb-3">
                                        {setDisabled(false)}
                                        <Volver ultimoPaso={1} {...props} />
                                        <Continuar spinner={buscando} />
                                    </div>
                                }
                                {errorAspirante && <SnackBarCustom tipo="error" mensaje={errorAspirante} />}
                                {errorPaso1 && <SnackBarCustom tipo="error" mensaje={errorPaso1} />}
                            </Form>
                        }
                    </Formik>
                </>
            }
        </PreInscripcionUIConsumer>
    )
};

export default Documentacion;